import { SearchResultType } from "../enum/search-result-type.enum";
import { SearchRole } from "../enum/search-role.enum";
import { SearchResultItem } from "./search-result-item";

export class SearchMessageDto{
  threadId!: string;
  messages:ChatMessage[] = new Array<ChatMessage>();
  constructor(){
    this.threadId = crypto.randomUUID();
    this.messages = [];
  }
}

export class ChatMessage{
    content!:string;
    role!: SearchRole;

    // For forntend
    freeText?:string;
    message?:string;
    searchResultItems?: SearchResultItem[];
    totalCount?:number;
    searchResultType?:SearchResultType;
    impersonateWith?:string;
    feedbackGiven?: 'up' | 'down';
    requestId?: string;
    submittingFeedbackState?: 'up' | 'down';
}
